import { render, staticRenderFns } from "./AddPrivateEventModal.vue?vue&type=template&id=10b75f91&scoped=true&"
import script from "./AddPrivateEventModal.vue?vue&type=script&lang=js&"
export * from "./AddPrivateEventModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPrivateEventModal.vue?vue&type=style&index=0&id=10b75f91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b75f91",
  null
  
)

export default component.exports